<template>
    <v-dialog
            v-model="modelValue"
            :width="1000"
            persistent
    >
        <v-card>
            <div class="">
                <div class="d-flex align-center primary pl-3 pr-2">
                    <div class="flex-grow-1 sub--text">
                        Import Blocks
                    </div>
                    <div>
                        <v-btn
                                icon
                                color="white"
                                small
                                @click="modelValue = false"
                        >
                            <v-icon small>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </div>
                <v-divider></v-divider>
                <div class="" style="overflow-x: hidden; overflow-y: hidden">
                    <v-tabs v-model="page">
                        <v-tab>
                            Data
                        </v-tab>
                        <v-tab :disabled="!importDataRaw || !importFarm">
                            Review
                        </v-tab>
                        <v-tab :disabled="!importDataRaw || !importFarm || !importData || !importData.length">
                            Process
                        </v-tab>
<!--Data-->
                        <v-tab-item>
                            <v-card flat>
                                <v-card-text class="py-0">
                                    <v-autocomplete
                                            color="primary"
                                            dense
                                            hide-details
                                            item-text="description"
                                            item-value="id"
                                            :items="farms"
                                            label="Select Farm"
                                            class="pt-4"
                                            v-model="importFarm"
                                    />
                                    <v-textarea
                                            class="pt-3"
                                            label="Please Paste Data From The Excel Template Here"
                                            hide-details
                                            color="primary"
                                            v-model="importDataRaw"
                                            rows="5"
                                    />
                                </v-card-text>
                                <v-card-actions>

                                    <v-spacer/>
                                    <v-btn
                                            :disabled="!importDataRaw || !importFarm"
                                            small
                                            color="primary"
                                            @click="page = ++page"
                                    >Next</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-tab-item>

<!--Review-->
                        <v-tab-item>
                            <v-card flat>
                                <v-card-text class="pa-0" style="overflow-x: auto">
                                    <v-data-table
                                            :headers="importHeaders"
                                            :items="importData"
                                            :items-per-page="5"
                                            class="elevation-1"
                                            style="min-width: 1000px"
                                    ></v-data-table>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer/>
                                    <v-btn
                                            :disabled="!importData || !importData.length"
                                            small
                                            color="primary"
                                            @click="page = ++page"
                                    >Next</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-tab-item>
                        <v-tab-item>
                            <v-card flat>
                                <v-card-text class="py-0">
                                    <div class="d-flex font-weight-medium">
                                        <div class="flex-equal flex-grow-1">Processed:</div>
                                        <div class="flex-equal flex-grow-1">{{importResult.processed}}</div>
                                    </div>
                                    <div class="d-flex green--text font-weight-medium">
                                        <div class="flex-equal flex-grow-1">Inserted:</div>
                                        <div class="flex-equal flex-grow-1">{{importResult.inserted}}</div>
                                    </div>
                                    <div class="d-flex green--text font-weight-medium">
                                        <div class="flex-equal flex-grow-1">Updated:</div>
                                        <div class="flex-equal flex-grow-1">{{importResult.updated}}</div>
                                    </div>
                                    <div class="d-flex red--text font-weight-medium">
                                        <div class="flex-equal flex-grow-1">Errors:</div>
                                        <div class="flex-equal flex-grow-1">{{importResult.errors}}</div>
                                    </div>
                                    <v-progress-linear class="my-2" color="secondary" :value="importResult.progress"/>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer/>
                                    <v-btn
                                            v-if="!importResult.ran"
                                            small
                                            color="primary"
                                            @click="startImport()"
                                    >Start Import</v-btn>
                                    <v-btn
                                            v-else
                                            :disabled="importing"
                                            :loading="importing"
                                            small
                                            color="primary"
                                            @click="modelValue = false"
                                    >Done</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-tab-item>
                    </v-tabs>
                </div>
<!--                <div class="text-right pr-2 pt-2 pb-2">-->
<!--                    <v-btn-->
<!--                            @click="validateSave()"-->
<!--                            fab-->
<!--                            small-->
<!--                            color="secondary"-->
<!--                            :loading="loading"-->
<!--                            :disabled="!changesMade || loading"-->
<!--                    >-->
<!--                        <v-icon v-if="!loading">mdi-content-save</v-icon>-->
<!--                    </v-btn>-->
<!--                </div>-->
            </div>
        </v-card>
    </v-dialog>
</template>

<script>


import {mapGetters} from "vuex";

export default {
    components: {},
    props: {
        value: Boolean,
        selectedFarm: Number
    },
    data() {
        return {
            page: 0,
            importFarm: null,
            importDataRaw: null,
            importHeaders: [
                {value: 'blockName', text: 'Block Name', sortable: true},
                {value: 'variety', text: 'Variety', sortable: true},
                {value: 'barcodes', text: 'Barcodes', sortable: true},
                {value: 'uuid', text: 'UUID', sortable: true},
            ],
            importResult: {
                ran: false,
                index: 0,
                progress: 0,
                processed: 0,
                errors: 0,
                updated: 0,
                inserted: 0
            },
            importing: false
        }
    },
    watch: {
        page: {
            immediate:true,
            handler(val) {
                this.importFarm = this.farms.filter(farm => farm.id === this.selectedFarm).shift()

                if (val === 2)
                    this.importResult = {
                        ran: false,
                        index: 0,
                        progress: 0,
                        processed: `0 of ${this.importData.length}`,
                        errors: 0,
                        updated: 0,
                        inserted: 0
                    }
            }
        }
    },
    methods: {

        async startImport() {

            this.importResult.ran = true

            const vm = this

            const importItem = (item) => {
                return new Promise( (resolve) => {
                    vm.$newReq('POST', `setup/import/block`, item)
                        .then((res) => {
                            if (res === 'updated')
                                vm.importResult.updated = ++vm.importResult.updated
                            else
                                vm.importResult.inserted = ++vm.importResult.inserted
                            console.log(res)
                        })
                        .catch(e => {
                            console.log(e)
                            vm.importResult.errors = ++vm.importResult.errors
                        })
                        .finally(() => {
                            vm.importResult.index = ++vm.importResult.index
                            vm.importResult.progress = Math.floor(((vm.importResult.index + 1) / vm.importData.length) * 100)
                            vm.importResult.processed = `${vm.importResult.index} of ${vm.importData.length}`
                            resolve(true)
                        })
                })
            }
            this.importing = true;

            for (const row of this.importData) {
                await importItem(row)
            }

            this.importing = false;
        }
    },
    computed: {
        ...mapGetters(['farms']),

        importData() {
            try {
                let rows = this.importDataRaw.split(/\n/g)
                const headers = rows.shift().split(/\t/g)

                rows = rows.reduce((rows, line) => {
                    if (!line)
                        return rows
                    try {
                        const items = line.split(/\t/g);
                        const obj = items.reduce((obj, value, index) => {
                            obj[headers[index]] = value || null;
                            return obj
                        }, {})
                        rows.push(obj);
                        return rows;
                    } catch (e) {
                        return rows
                    }
                }, []);

                console.table(rows)


                let rowValues = rows.reduce((list, obj) => {
                    try {
                        const block = {
                            blockName: (obj['BLOCK NAME'] || '').trim(),
                            variety: (obj['VARIETY'] || '').trim(),
                            barcodes: [],
                            uuid: (obj['UUID'] || '').trim(),
                            fkFarm: this.importFarm.id
                        }

                        if (obj['UNIQUE CODE 1'])
                            block.barcodes.push(obj['UNIQUE CODE 1'])

                        if (obj['UNIQUE CODE 2'])
                            block.barcodes.push(obj['UNIQUE CODE 2'])
                        list.push(block)
                        return list
                    } catch (e) {
                        console.log(e)
                        return list
                    }
                }, [])

                console.table(rowValues)
                return rowValues
            } catch (e) {
                return 'null'
            }
        },


        modelValue: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
}
</script>

<style scoped>

</style>